import React, { useEffect } from "react";
import GradientHybridModalNarrow from "../UI/Modals/Hybrid/GradientHybridModalNarrow";
import {
  SmallButtonPurple,
  SmallButtonLightGrey,
} from "../UI/Buttons/SmallButton";
import creator from "../../assets/gifs/Digital presentation.gif";
import styled from "styled-components";
import { connect } from "react-redux";
import * as actions from "../../store/actions";
import { useTour } from "@reactour/tour";
const ModalBody = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const ModalButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;
const ModalHeading = styled.h2``;

function WebsiteTourModal(props) {
  const {
    currentStep,
    isOpen: isTourOpen,
    setIsOpen,
    setCurrentStep,
  } = useTour();
  useEffect(() => {
    if (
      currentStep === 10 && isTourOpen && props.is_tour_completed != null
        ? !props.is_tour_completed
        : false
    ) {
      props.updateTourCompleted(props.accessToken, props.userId, true);
    }
  }, [
    currentStep,
    isTourOpen,
    props.is_tour_completed,
    props.accessToken,
    props.userId,
    props.updateTourCompleted,
  ]);

  const handleRequestClose = () => {
    props.updateTourCompleted(props.accessToken, props.userId, true);
  };

  return (
    <GradientHybridModalNarrow
      isOpen={
        (props.is_tour_completed != null ? !props.is_tour_completed : false) &&
        !isTourOpen
      }
      onRequestClose={handleRequestClose}
      shouldCloseOnOverlayClick={true}
      padding={"20px"}
      maxHeight={"90vh"}
      width={"50vw"}
    >
      <ModalBody>
        <ModalHeading>Welcome to Capture My Meeting</ModalHeading>
        <img src={creator} style={{ width: "65%" }} alt="" />
        <ModalButtonsContainer>
          <SmallButtonPurple
            style={{ padding: "10px 20px", width: "fit-content" }}
            onClick={() => {
              setCurrentStep(0);
              setIsOpen(true);
            }}
          >
            Take Tour
          </SmallButtonPurple>
          <SmallButtonLightGrey
            style={{ padding: "10px 20px", width: "fit-content" }}
            onClick={() => {
              props.updateTourCompleted(props.accessToken, props.userId, true);
            }}
          >
            Skip
          </SmallButtonLightGrey>
        </ModalButtonsContainer>
      </ModalBody>
    </GradientHybridModalNarrow>
  );
  // Map dispatch functions to component props
}
const mapDispatchToProps = (dispatch) => {
  return {
    updateTourCompleted: (accessToken, userId, is_tour_completed) =>
      dispatch(
        actions.updateTourCompleted(accessToken, userId, is_tour_completed)
      ),
  };
};
const mapStateToProps = (state) => {
  return {
    accessToken: state.auth.accessToken,
    userId: state.user.userId,
    is_tour_completed: state.user.is_tour_completed,
  };
};
// Connect the component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(WebsiteTourModal);
